export var PregnancyStatusNum;
(function (PregnancyStatusNum) {
    PregnancyStatusNum["NotBorn"] = "notBorn";
    PregnancyStatusNum["Born"] = "born";
    PregnancyStatusNum["Miscarriage"] = "miscarriage";
})(PregnancyStatusNum || (PregnancyStatusNum = {}));
